module.exports = __webpack_public_path__ + "static/media/no-smoking-dark-gray.8fecf0f5.svg";